import React from "react";
import { Colors } from "../../design/Colors";
import { Fonts } from "../../design/Font";

export default class Button extends React.Component{

    constructor(props){
        super(props);
        this.state={
            isFocused:false,
            secure:false,
        }
    }

    render() {
        const { title, onClick,width,height,color} = this.props;
        return (
            <div onClick={onClick} style={{display:"flex", cursor:'pointer', backgroundColor:color?color:Colors.blue,width:width, height:height, borderRadius:4,}}>
                <text style={{...Fonts.white_text,cursor:'pointer', color:Colors.white, textAlign:'center',width:"100%", alignSelf:'center'}}>{title}</text>
            </div>
        );
    }
}